mutation SupplierExport($input: SupplierExportInput!) {
  supplierExport(input: $input) {
    exportResult {
      exportCycles
    }
  }
}
